import React, { useState } from 'react'
import { v4 as uuid } from 'uuid'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { IconPlaylistAdd } from '@tabler/icons-react'
import { SearchableDropdown } from '@/components/dropdowns/SearchableDropdown'
import { setMassPlaybookUpdateCategorySelection } from '@/reducers/playbooks/playbooks.redux'
import { ErrorMessage } from '@/components/forms/ErrorMessage'
import { AbstractForm } from '@/components/forms/formik/AbstractForm'
import { BasicModal } from '@/components/layout/modals/BasicModal'
import { accessorSectionMap } from '../../playbook.helpers'

const SelectCategory = ({ playbookId }) => {
  const dispatch = useDispatch()
  const { section } = useParams()
  const [newCategoryModalOpen, setNewCategoryModalOpen] = useState(false)
  const [addedOptions, setAddedOptions] = useState([])
  const { playbooks, massPlaybookUpdate } = useSelector((state) => state.playbooks)
  const { categorySelection, selection } = massPlaybookUpdate

  const accessor = accessorSectionMap[section]
  const playbook = playbooks.find((p) => p.id.toString() === playbookId.toString())
  const categories = playbook.body[accessor]

  const categoryOptions = categories
    ? categories.order.map((categoryId) => {
        return {
          value: categoryId,
          label: categories.entries[categoryId]?.name,
          isNew: false,
        }
      })
    : []
  const options = [...categoryOptions, ...addedOptions]

  const selectedCategory = categorySelection[playbookId]
  const isSelected = selection.map((s) => s.split('_')[0]).includes(playbookId)
  const showWarning = !selectedCategory && isSelected

  const handleNewCategoryModalOpen = () => setNewCategoryModalOpen(true)
  const handleNewCategoryModalClose = () => setNewCategoryModalOpen(false)

  const handleCategorySelect = (categoryId) => {
    const option = options.find((o) => o.value === categoryId)
    dispatch(
      setMassPlaybookUpdateCategorySelection({
        ...categorySelection,
        [playbookId]: { categoryId, isNew: option?.isNew, name: option?.label },
      })
    )
  }

  const handleCreateCategory = (category) => {
    const newId = uuid()
    setAddedOptions([...addedOptions, { value: newId, label: category.name, isNew: true }])
    dispatch(
      setMassPlaybookUpdateCategorySelection({
        ...categorySelection,
        [playbookId]: { categoryId: newId, isNew: true, name: category.name },
      })
    )
    handleNewCategoryModalClose()
  }

  const actions = [
    {
      key: 'new-category',
      fn: handleNewCategoryModalOpen,
      label: (
        <div className="flex-align-center small-gap">
          <IconPlaylistAdd className="icon-svg status-brand" />
          Add Category
        </div>
      ),
    },
  ]

  return (
    <>
      <div className="flex-space-between medium-gap">
        <SearchableDropdown
          actions={actions}
          buttonLabel="Select Category"
          buttonProps={{ small: true }}
          handleSelect={handleCategorySelect}
          hideSearch
          inputProps={{ placeholder: 'Search...' }}
          placement="bottom-end"
          options={options}
          selected={selectedCategory?.categoryId}
        />
        {showWarning ? <ErrorMessage /> : <div style={{ width: 25 }} />}
      </div>

      {newCategoryModalOpen && (
        <BasicModal
          data-testid="add-new-category"
          title="New Category"
          onClose={handleNewCategoryModalClose}
          show={newCategoryModalOpen}
          size="tiny"
        >
          <AbstractForm
            schema={[
              {
                name: 'name',
                type: 'text',
                label: 'Category Name',
                required: true,
                autoFocus: true,
              },
            ]}
            onSubmit={handleCreateCategory}
            buttonLabel="Create new category"
            onClose={handleNewCategoryModalClose}
            isModal
          />
        </BasicModal>
      )}
    </>
  )
}

export default SelectCategory
